import React from "react";
import shortid from "shortid";
import moment from "moment";
import swal from "sweetalert2";
import { spmfcloudFunctionUrl } from "../../../actions/salesforces";

export const applicationDownloadUrl = "https://stspmf.my.salesforce.com/sfc/p/7F000002bBSH/a/OQ000001NzyH/us1JKR7yQHCo1s0ePUUY_6oOmbXQLRTIwtDJoXhnuoo"

export const getAttachmentFromFile = (path) => {
  return fetch(path, { headers: { credentials: "include" } }).then((r) =>
    r.blob()
  );
};

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader.result.replace(/^data:(.*;base64,)?/, "");
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    reader.onerror = (error) => reject(error);
  });
}

export const applicationSteps = [
  {
    title: "Start",
    href: "#",
    onClick: (e) => {
      e.preventDefault();
    },
  },
  {
    title: "Application Profile ",
    href: "#",
    onClick: (e) => {
      e.preventDefault();
    },
  },
  {
    title: "Beneficiaries List",
    href: "#",
    onClick: (e) => {
      e.preventDefault();
    },
  },
  {
    title: "Other household members",
    href: "#",
    onClick: (e) => {
      e.preventDefault();
    },
  },
  {
    title: "Agreement",
    href: "#",
    onClick: (e) => {
      e.preventDefault();
    },
  },
];

// Need to be binded with main component
export function validateInput(validationList = [], buttonValidation = false) {
  const { form, errorMessage } = this.state;
  Object.keys(buttonValidation ? validationList : form).forEach((key) => {
    if (validationList[key] === undefined) return;
    if (typeof validationList[key].validate === "function") {
      if (validationList[key].validate(form[key]) === false) {
        errorMessage[key] =
          validationList[key].message ||
          `${key.replace(/__c|_/g, " ")} required`;
      } else {
        delete errorMessage[key];
      }
    }
  });
  this.setState({ errorMessage });
  return Object.keys(errorMessage).length === 0;
}

/**
 * Checking validity of the form
 * @param {*} validationList can be function or array
 * @param {*} validateAll prompt if validation first before form
 * @param {*} index which array index need to be validated
 */
export function validateInputArray(
  validationList = [],
  validateAll = false,
  index = 0
) {
  const { form, errorMessage } = this.state;
  errorMessage[index] = errorMessage[index] || {};
  if (validateAll === true) {
    Object.keys(form).forEach((formIndex) => {
      let eachValidationList = validationList;
      errorMessage[formIndex] = errorMessage[formIndex] || {};
      if (typeof validationList === "function")
        eachValidationList = validationList(formIndex);
      Object.keys(eachValidationList).forEach((key) => {
        if (typeof eachValidationList[key].validate === "function") {
          if (
            eachValidationList[key].validate(form[formIndex][key]) === false
          ) {
            errorMessage[formIndex][key] =
              eachValidationList[key].message ||
              `${key.replace(/__c|_/g, " ")} required`;
          } else {
            delete errorMessage[formIndex][key];
          }
        }
      });
    });
  } else {
    Object.keys(form[index]).forEach((key) => {
      if (validationList[key]) {
        if (typeof validationList[key].validate === "function") {
          if (validationList[key].validate(form[index][key]) === false) {
            errorMessage[index][key] =
              validationList[key].message ||
              `${key.replace(/__c|_/g, " ")} required`;
          } else {
            delete errorMessage[index][key];
          }
        }
      }
    });
  }
  this.setState({ errorMessage });
  const error = errorMessage.map(
    (eachError) => Object.keys(eachError).length === 0
  );
  return error.indexOf(false) === -1;
}

// Redux function
export const changeStep = (stepNumber) => ({
  type: "CHANGE_REGISTRATION_STEP",
  payload: stepNumber,
});

export const changeDraftId = (draftId) => ({
  type: "CHANGE_DRAFT_ID",
  payload: draftId,
});

export const describeAllObject = () => async (dispatch, getState) => {
  const { hash } = getState().user.siteToken;
  const { timeFetched } = getState().objectInfo;
  if (new Date().getTime() - timeFetched < 1000 * 3600) return;
  const objToDescibed = [
    "Person__c",
    "Fund_Request__c",
    "Application__c",
    "Receipt__c",
    "Contact",
    "Account",
  ];
  const requests = objToDescibed.map((obj) =>
    fetch(`${spmfcloudFunctionUrl}/sf/describe/${obj}`, {
      headers: {
        "Content-Type": "application/json",
        "hash-token": hash,
      },
      method: "GET",
    }).then((res) => res.json())
  );
  const results = await Promise.all(requests);
  results.map((result) =>
    result.describe.name
      ? dispatch({
          type: "DESCRIBE_OBJECT",
          payload: {
            objectName: result.describe.name,
            objectDescription: result.describe.fields,
          },
        })
      : null
  );
};

// convert describe picklist value into picklist value
// Type can be component or plain object
export const getPicklist = (
  fieldName = "",
  objectFieldList = [],
  type = "component",
  exception = []
) => {
  const fieldInformation = objectFieldList.filter((o) => o.name === fieldName);
  
  if (fieldInformation.length === 0) return [];
  const options = fieldInformation[0].picklistValues
    .filter((o) => o.active === true)
    .filter(x => exception.filter(y => y === x.value).length <= 0)
    .map((pickList) => (
      <option key={shortid()} value={pickList.value}>
        {pickList.label}
      </option>
    ));
  return type === "component" ? options : fieldInformation[0].picklistValues;
};

// Get all school
export const getAllSchool = () => async (dispatch, getState) => {
  const { user } = getState();
  const schools = await fetch(`${spmfcloudFunctionUrl}/sf/school`, {
    headers: {
      "Content-Type": "application/json",
      "hash-token": user.siteToken.hash,
    },
    method: "GET",
  }).then((res) => res.json());
  dispatch({ type: "SCHOOL_LIST", payload: schools.records });
};

// update registration data into redux
export const updateRegistrationData = (tabNumber = 0, data) => ({
  type: "UPDATE_TAB_DATA",
  payload: {
    tabNumber,
    data,
  },
});

export const updateAttachment = (tabNumber, attachment) => ({
  type: "UPDATE_ATTACHMENT",
  payload: {
    attachment,
    tabNumber,
  },
});

export const removeLoading = () => ({
  type: "REGISTRATION_LOADING",
  payload: false,
});

export const saveAndPostRegistration =
  (consent) => async (dispatch, getState) => {
    const { siteToken, key } = getState().user;
    const { tab2, tab3, tab4, attachment, isRenew, draftId } =
      getState().registration;
    try {
      dispatch({ type: "REGISTRATION_LOADING", payload: true });
      dispatch({
        type: "REGISTRATION_LOADING_MESSAGE",
        payload: "Creating Application...",
      });
      const result = await fetch(
        `${spmfcloudFunctionUrl}/registration/create`,
        {
          body: JSON.stringify({
            tab2: JSON.stringify({
              ...tab2,
              Date_of_Birth__c: moment(tab2.Date_of_Birth__c).format(
                "YYYY-MM-DD"
              ),
            }),
            tab3: tab3.map((o) => ({
              ...o,
              Date_of_Birth__c: moment(o.Date_of_Birth__c).format("YYYY-MM-DD"),
              Payout_Start__c: moment(o.Payout_Start__c).format("YYYY-MM-DD"),
            })),
            tab4: tab4.map((o) => ({
              ...o,
              Date_of_Birth__c: moment(o.Date_of_Birth__c).format("YYYY-MM-DD"),
            })),
            consent,
            isRenew,
          }),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "hash-token": siteToken.hash,
          },
        }
      ).then(async (res) => {
        const json = await res.json();
        if (res.ok) return json;
        throw new Error(json.message);
      });
      const resolveAttachment = (attachmentTab, type = "Beneficiary") =>
        attachmentTab.map(async (o, index) => {
          if (o === undefined || o === null)
            return new Promise((resolve) => resolve(null));
          const promiseList = Object.keys(o).map(async (k) => {
            delete o[k].index;
            delete o[k].key;
            if (o[k].Body === undefined) {
              const attachmentBlob = await getAttachmentFromFile(o[k].fileData);
              const base64 = await getBase64(attachmentBlob);
              return {
                ...o[k],
                Body: base64,
                parentId:
                  type === "Beneficiary"
                    ? result.beneficiaries[index].id
                    : result.houseHoldMember[index].id,
              };
            }
            return {
              ...o[k],
              parentId: result.houseHoldMember[index].id,
            };
          });
          return Promise.all(promiseList || []);
        });
      dispatch({
        type: "REGISTRATION_LOADING_MESSAGE",
        payload: "Uploading Attachment...",
      });

      const resolveTab4Attachment = await Promise.all(
        resolveAttachment(attachment.tab4, "HouseholdMember")
      );
      const resolveTab3Attachment = await Promise.all(
        resolveAttachment(attachment.tab3, "Beneficiary")
      );
      const compiledTab4 = [];
      const compiledTab3 = [];
      resolveTab4Attachment.map((o) => {
        if (o) {
          o.map((i) => {
            delete i.fileData;
            compiledTab4.push(i);
          });
        }
      });

      resolveTab3Attachment.map((o) => {
        if (o) {
          o.map((i) => {
            delete i.fileData;
            compiledTab3.push(i);
          });
        }
      });
      if (draftId) {
        fetch(`${spmfcloudFunctionUrl}/draft/applications/delete/${draftId}`, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "hash-token": siteToken.hash,
          },
        });
      }
      await fetch(`${spmfcloudFunctionUrl}/registration/upload-attachment`, {
        body: JSON.stringify({
          tab4Attachment: compiledTab4,
          tab3Attachment: compiledTab3,
        }),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "hash-token": siteToken.hash,
        },
      }).then(async (res) => {
        const json = await res.json();
        if (res.ok) return json;
        throw new Error(json.message);
      });
      // swal.fire('Success', result.message, 'success');
      dispatch({ type: "APPLICATION_CREATED", payload: result.id });
      dispatch({ type: "REGISTRATION_LOADING", payload: false });
      swal
        .fire({
          title: "Success",
          text: result.message,
          type: "success",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "New Application",
        })
        .then(() => {
          window.location = "/portal/registration-v2?new=true";
        });
    } catch (error) {
      swal.fire("An error occured.", error.toString(), "error");
      dispatch({ type: "REGISTRATION_LOADING", payload: false });
    }
  };

export const resetRegistration = async () => {
  const result = await swal.fire({
    title: "Are you sure to reset all form in this registration?",
    text: "You won't be able to revert this!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, clear now.",
  });
  if (result.value) {
    setTimeout(() => {
      window.location = "/portal/registration-v2/";
    }, 1000);
    return {
      type: "RESET_REGISTRATION",
    };
  }
  return { type: "", payload: null };
};

export const resetApplicationId = () => ({
  type: "RESET_APPLICATION",
});

export const getSchoolById = (schools, id) => {
  const result = schools.filter((o) => o.value === id);
  return result.length > 0 ? result[0].label : "";
};

export const registerRecordType = () => async (dispatch, getState) => {
  const RecordType = {};
  const { user } = getState();
  const recordTypes = await fetch(
    `${spmfcloudFunctionUrl}/sf/all-record-type`,
    {
      mode: "cors",
      cache: "no-cache",
      method: "GET",
      headers: {
        "hash-token": user.siteToken.hash,
      },
    }
  ).then(async (response) => {
    const json = await response.json();
    if (!response.ok) {
      throw new Error(json.message);
    }

    return json;
  });
  recordTypes.records.forEach((recType) => {
    if (recType.SobjectType === "Person__c") {
      if (recType.Name === "Beneficiary") {
        RecordType.Beneficiary = recType.Id;
      } else if (recType.Name === "Household Member") {
        RecordType.Household_Member = recType.Id;
      }
    }
  });

  dispatch({
    type: "RECORD_TYPE",
    payload: RecordType,
  });
};

export const processAttachment = (attachmentObject = []) =>
  attachmentObject.map(async (o, index) => {
    if (o === null || o === undefined)
      return new Promise((resolve) => resolve(null));
    const promiseList = Object.keys(o)
      .map(async (k) => {
        if (o[k]) {
          if (o[k].Body) return o[k];
          const attachmentBlob = await getAttachmentFromFile(o[k].fileData);
          const base64 = await getBase64(attachmentBlob);
          return {
            ...o[k],
            Body: base64,
            parentId: null,
            index,
            key: k,
          };
        }
        return null;
      })
      .filter((a) => a !== null || a !== undefined);
    return Promise.all(promiseList);
  });

export const saveAsDraft = () => async (dispatch, getState) => {
  const { siteToken, key } = getState().user;
  const { tab2, tab3, tab4, attachment, draftId, isRenew } =
    getState().registration;
  try {
    dispatch({ type: "REGISTRATION_LOADING", payload: true });
    dispatch({
      type: "REGISTRATION_LOADING_MESSAGE",
      payload: "Saving draft...",
    });
    const tab4Attachment = await Promise.all(
      processAttachment(attachment.tab4)
    );
    const parsedAttachmentTab4 = tab4Attachment.map((xAttachment) => {
      if (xAttachment) {
        const newAttachment = {};
        xAttachment.forEach((o) => {
          newAttachment[o.key] = o;
        });
        return newAttachment;
      }
      return null;
    });
    const tab3Attachment = await Promise.all(
      processAttachment(attachment.tab3)
    );
    const parsedAttachmentTab3 = tab3Attachment.map((xAttachment) => {
      if (xAttachment) {
        const newAttachment = {};
        Object.keys(xAttachment).forEach((key1) => {
          newAttachment[xAttachment[key1].key] = xAttachment[key1];
        });
        return newAttachment;
      }
      return null;
    });
    const result = await fetch(
      `${spmfcloudFunctionUrl}/draft/applications/${draftId || ""}`,
      {
        body: JSON.stringify({
          tab2,
          tab3,
          tab4,
          consent: false,
          attachment: {
            tab4: parsedAttachmentTab4,
            tab3: parsedAttachmentTab3,
          },
          isRenew,
        }),
        method: draftId ? "PATCH" : "POST",
        headers: {
          "Content-Type": "application/json",
          "hash-token": siteToken.hash,
        },
      }
    ).then(async (res) => {
      const json = await res.json();
      if (res.ok) return json;
      throw new Error(json.message);
    });
    swal.fire({
      title: "Success",
      text: result.message,
      type: "success",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      // cancelButtonColor: '#d33',
      confirmButtonText: "Ok.",
    });
    dispatch({
      type: "CHANGE_DRAFT_ID",
      payload: draftId || result.data.draftId,
    });
    dispatch({ type: "REGISTRATION_LOADING", payload: false });
  } catch (error) {
    swal.fire("An error occured.", error.toString(), "error");
    dispatch({ type: "REGISTRATION_LOADING", payload: false });
  }
};

export const renewApplication = (id) => async (dispatch, getState) => {
  const { siteToken } = getState().user;

  try {
    dispatch({ type: "REGISTRATION_LOADING", payload: true });
    dispatch({
      type: "REGISTRATION_LOADING_MESSAGE",
      payload: "Getting renewal form...",
    });
    const result = await fetch(
      `${spmfcloudFunctionUrl}/registration/renew/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "hash-token": siteToken.hash,
        },
      }
    ).then((res) => res.json());
    const allowedValue = [
      "Full_Name__c",
      "ID_Type__c",
      "ID_Number__c",
      "Date_of_Birth__c",
      "Marital_Status__c",
      "Gender__c",
      "Nationality__c",
      "Other_Nationality__c",
      "Race__c",
      "Postal__c",
      "Street__c",
      "Block__c",
      "Unit_Number__c",
      "Flat_Type__c",
      "Other_Flat_Type__c",
      "Country__c",
      "Contact_Number__c",
      "Mobile_Phone__c",
      "Office_Phone__c",
      "Home_Phone__c",
      "Email_Address__c",
    ];
    const tab2 = {};
    // console.info(result.data.tab2);
    Object.keys(result.data.tab2).forEach((key) => {
      if (allowedValue.indexOf(key) > -1) {
        tab2[key] = result.data.tab2[key];
      }
    });
    tab2.Application_Type__c = "renewal";
    const allowedValueTab3 = [
      "Full_Name__c",
      "ID_Number__c",
      "Email_Address__c",
      "Date_of_Birth__c",
      "Gender__c",
      "Race__c",
      "Other_Race__c",
      "Nationality__c",
      "Other_Nationality__c",
      "Current_School__c",
      "Current_Level__c",
      "Relationship_to_Applicant__c",
      "Other_Relationship__c",
      "Payout_Start__c",
      "No_of_Receipts_Approved__c",
    ];
    const tab3 = result.data.tab3.map((o) => {
      const newData = {};
      Object.keys(o).forEach((key) => {
        if (allowedValueTab3.indexOf(key) > -1) {
          if (typeof o[key] === "number") newData[key] = o[key].toString();
          else newData[key] = o[key];
        }
      });
      return newData;
    });

    const allowedValueTab4 = [
      "Full_Name__c",
      "ID_Number__c",
      "Email_Address__c",
      "ID_Type__c",
      "Date_of_Birth__c",
      "Gender__c",
      "Race__c",
      "Other_Race__c",
      "Nationality__c",
      "Other_Nationality__c",
      "Relationship_to_Beneficiary__c",
      "Other_Relationship__c",
      "Monthly_Gross_Income__c",
      "Employment_Status__c",
      "Other_Source_of_Income__c",
      "Other_Source_of_Income_Amount__c",
      "Occupation__c",
      "Company__c",
      "Remarks__c"
    ];

    const tab4 = result.data.tab4.map((o, index) => {
      const newData = {};
      Object.keys(o).forEach((key) => {
        if (allowedValueTab4.indexOf(key) > -1) {
          if (typeof o[key] === "number") newData[key] = o[key].toString();
          else newData[key] = o[key];
        }
      });

      newData.mainApplicant = o.Main_Applicant__c || index === 0;
      return newData;
    });
    dispatch(updateRegistrationData(2, tab2));
    dispatch(updateRegistrationData(3, tab3));
    dispatch(updateRegistrationData(4, tab4));
    dispatch({ type: "RENEW_APPLICATION" });
    dispatch({ type: "REGISTRATION_LOADING", payload: false });
  } catch (error) {
    swal.fire("An error occured.", error.message, "error");
    dispatch({ type: "REGISTRATION_LOADING", payload: false });
  }
};

export const updateRenewState = () => ({ type: "RENEW_APPLICATION" });

export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/actions.js
// module id = 30
// module chunks = 0